/**
 * Conventional field_key for the freeform "dump context here" field seeded
 * by default on new ObjectTypes (Otto and the admin UI both seed it). Not a
 * schema-enforced column — an ordinary configured text field. Treat its
 * absence as normal: legacy or hand-built types may not have it.
 */
export const TRIBAL_KNOWLEDGE_FIELD_KEY = 'tribal_knowledge';
export const TRIBAL_KNOWLEDGE_FIELD_LABEL = 'Tribal Knowledge';

/**
 * Conventionally-named long-text field keys — not a schema-enforced list,
 * just field_keys the admin UI and Otto both tend to use for freeform prose.
 * Drives two things: showing a textarea (not a single-line input) in the edit
 * form, and rendering the value as markdown in the read-only detail view.
 */
export const LONG_TEXT_FIELD_KEYS = new Set([
  TRIBAL_KNOWLEDGE_FIELD_KEY,
  'notes',
  'description',
  'address',
  'scope',
  'findings',
  'conditions',
  'root_cause',
  'corrective_action',
  'containment_action',
  'closure_notes',
  'verification_method',
  'disposition_justification',
  'qualification_scope',
  'source_reference',
]);
